export default "__VITE_ASSET__Cli7FEjt__"